// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1KXZL","label":"LabeledBox_label__20kZc"};